function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.87 73.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.07,2.06c-.44,1.18-.38,4.67.12,7.75.5,3.08.6,9.43.23,14.1-.38,4.67-.75,11.43-.83,15-.11,4.6-.85,7.92-2.54,11.35C-.03,54.48-.27,56.06.21,62.42c.84,11.13,1.19,11.49,11.06,11.49,5.09,0,8.72-.46,9.46-1.2,1.47-1.47,1.53-14.45.1-20.8-.56-2.47-1.38-9-1.83-14.5C17.82,22.99,12.64,4.02,9.1,1.16c-2.19-1.77-3.12-1.56-4.02.9",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42,6.23c2.67,6.4,6.35,23.27,6.69,30.69l.34,7.5h-4.89s-4.89,0-4.89,0l.75-11.5c1.06-16.27,1.06-16.8.2-23.75-.87-6.95-.27-7.92,1.81-2.94",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.82,48.45c1.5,1.42,3.89,21.02,2.71,22.2-.37.37-3.59.86-7.15,1.09-8.89.57-9.46-.06-9.46-10.54,0-6.9.38-9,2.02-11.31,2.85-4,8.45-4.68,11.87-1.44",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.0ddbe748bf0541b1f0c272e8330d160d.svg";
export { ForwardRef as ReactComponent };